const items = [
  {
    icon: "ri-file-list-3-line",
    title: "貴重品・重要書類の仕分け",
    text: "通帳・印鑑・保険証券・権利書・契約書類など、相続に必要な重要書類を専用ケースに分類してお渡しします。",
  },
  {
    icon: "ri-heart-line",
    title: "思い出の品・形見分け",
    text: "写真・手紙・衣類などの思い出の品を、ご家族様のご要望に沿って丁寧に仕分け。形見分けをお手伝いします。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "供養品の合同供養",
    text: "仏壇・位牌・お線香・掛け軸などの宗教的な品々は、提携寺院での合同供養を承ります。",
  },
  {
    icon: "ri-truck-line",
    title: "家具・家電の搬出処分",
    text: "遺品整理後の家具・家電・不用品の搬出・処分まで一貫対応。分別・リサイクルも適正に行います。",
  },
];

export default function Items() {
  return (
    <section id="items" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            ITEMS
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            遺品整理の<span className="text-primary-500">具体的な作業内容</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            貴重品の仕分けから供養、搬出・処分まで、遺品整理に必要な作業を一貫して承ります。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {items.map((it) => (
            <div
              key={it.title}
              className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-7"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-100 mb-5">
                <i className={`${it.icon} text-secondary-700 text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3">
                {it.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}